import { Build, AnnotationScope } from "~/components/build/Show/lib/types";

export function getAnnotationCounts(build: Build): Record<AnnotationScope, number> & {
  totalCount: number;
} {
  const buildCount = Object.values(build.annotationCountsByStyle).reduce(
    (sum, count) => sum + count,
    0,
  );
  const jobCount = Object.values(build.statistics?.jobAnnotationCountsByStyle || {}).reduce(
    (sum, count) => sum + count,
    0,
  );

  return {
    build: buildCount,
    job: jobCount,
    totalCount: buildCount + jobCount,
  };
}
